import {Component, OnInit} from '@angular/core';
import {NgbActiveModal, NgbModal} from '@ng-bootstrap/ng-bootstrap';
import {Dialog} from '../../../global/util/Dialog';
import {FormBuilder} from '@angular/forms';
import {Constant} from '../../../global/util/Constant';
import {VerifierService} from '../../../user/service/verifier.service';

@Component({
  selector: 'app-certificate-detail',
  templateUrl: './certificate-detail.component.html',
  styleUrls: ['./certificate-detail.component.css']
})
export class CertificateDetailComponent implements OnInit {
  public operatorInfo: any;
  public resumeHashResource: string;
  public index: number;
  public loading: boolean;
  public haveDocumentIntegrity: boolean;
  public documentFrontSrc: string | ArrayBuffer;
  public documentRearSrc: string | ArrayBuffer;
  // Está condición nos permite descargar el certificado publico del firmante desde el validador de firmas.
  public downloadValidatorPdf: boolean;
  // Este paramatro se usa para obtener el archivo seleccionado desde el validador de firmas del PDF.
  public fileSelected: any;

  constructor(public activeModal: NgbActiveModal,
              private formBuilder: FormBuilder,
              private verifierService: VerifierService,
              private modalService: NgbModal) {
    Dialog.createInstance(modalService);
  }

  ngOnInit(): void {
    if (this.operatorInfo.documentIntegrity) {
      this.buildSrcImage();
    }
  }

  public downloadCertificate() {
    this.loading = true;
    if (!this.downloadValidatorPdf) {
      const url = Constant.ROOT_API_V1.concat('/public/document/resource/',
        this.resumeHashResource,
        '/index/',
        String(this.index),
        '/certificate/stream');
      this.verifierService.downloadCertificateFile(url).subscribe(next => {
        const control = document.createElement('a');
        control.setAttribute('style', 'display:none;');
        document.body.appendChild(control);
        control.href = window.URL.createObjectURL(next);
        control.download = this.operatorInfo.issuerCertName.concat('.cer');
        control.click();
        this.loading = false;
      }, () => {
        this.loading = false;
      });
    } else {
      // Este acción se realiza cuando la descarga el certificado .cer desde el validador de firmas - pdf-validator
      const url = Constant.ROOT_API_V1.concat('/public/certificate/stream');
      const formData = new FormData();
      formData.append('file', this.fileSelected, this.fileSelected.name);
      formData.append('index', String(this.index));
      this.verifierService.downloadCertificate(url , formData).subscribe(next => {
        const control = document.createElement('a');
        control.setAttribute('style', 'display:none;');
        document.body.appendChild(control);
        control.href = window.URL.createObjectURL(next);
        control.download = this.operatorInfo.issuerCertName.concat('.cer');
        control.click();
        this.loading = false;
      }, () => {
        this.loading = false;
      });
    }
  }

  buildSrcImage() {
    this.documentFrontSrc = this.operatorInfo.documentFrontBase64Data ? 'data:image/' + this.operatorInfo.extensionDocumentFront + ';base64,' + this.operatorInfo.documentFrontBase64Data : this.defaultDocumentFrontSrc;
    this.documentRearSrc = this.operatorInfo.documentRearBase64Data ? 'data:image/' + this.operatorInfo.extensionDocumentRear + ';base64,' + this.operatorInfo.documentRearBase64Data : this.defaultDocumentRearSrc;
  }

  get defaultDocumentFrontSrc(): string | ArrayBuffer {
    return this.documentFrontSrc || this.placeHoldItRubric;
  }

  get defaultDocumentRearSrc(): string | ArrayBuffer {
    return this.documentRearSrc || this.placeHoldItRubric;
  }

  get placeHoldItRubric(): string {
    return Constant.DEFAULT_IMAGE_PATH_235_150;
  }

}
